import clsx from 'clsx'
import { Icon } from 'components'
import { TabsProps } from 'interfaces'
import React, { FC } from 'react'

export const Tabs: FC<TabsProps> = props => {
	const {
		onChange,
		options,
		value: selectedTab,
		className,
		classNameButton
	} = props
	return (
		<div
			className={clsx(
				className,
				'flex justify-center px-16 pt-2 shadow-md gap-16 w-fit bg-white rounded-lg  overflow-x-auto'
			)}
		>
			{options
				.filter(option => !option.disabled)
				.map(option => (
					<button
						key={option.value}
						type="button"
						className={clsx(
							'bg-transparent-default text-center flex',
							option.icon ? 'items-center gap-2' : 'flex-col',
							selectedTab === option.value && 'border-b-primary',
							classNameButton
						)}
						onClick={() => onChange?.(option.value)}
					>
						{option.icon && (
							<Icon
								fillPath
								src={option.icon}
								className={clsx(
									'h-4 w-4 ',
									selectedTab === option.value
										? 'text-blue-primary'
										: '!text-gray-9'
								)}
							/>
						)}
						<span
							className={clsx(
								'px-1 mb-1 !leading-none',
								selectedTab === option.value && 'text-blue-primary'
							)}
						>
							{option.label}
						</span>
						{!option.icon && (
							<div
								className={clsx(
									'rounded-lg bg-blue-primary h-1 w-full',
									selectedTab !== option.value && 'invisible'
								)}
							/>
						)}
					</button>
				))}
		</div>
	)
}
